import HotZoneModal from './HotZoneModal'

export default HotZoneModal
